var e = /* @__PURE__ */ ((r) => (r.BLOCK = "block", r.SMALL = "small", r.REVERSED = "reversed", r))(e || {});
export {
  e as ButtonModifiers
};
//# sourceMappingURL=ButtonModifiers.type.mjs.map
